/* eslint-disable*/
import { Box, Button, Divider, Grid, List, ListItem, Paper, Typography } from '@material-ui/core';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import AddCircleOutlineSharpIcon from '@material-ui/icons/AddCircleOutlineSharp';
import { ReactComponent as EditPenIconGreen } from '../../../assets/images/EditPenGreen.svg';
import FilterComponent from '../Amenities/FilterComponent';
import { SectionUserInfo } from '../../../components/Common';
// import Carousel from "react-simply-carousel";
import {
  closestCenter,
  DndContext,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { arrayMove, rectSortingStrategy, SortableContext } from '@dnd-kit/sortable';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import Carousel from 'react-material-ui-carousel';
import ShowMoreText from 'react-show-more-text';
import { backendLocalUrl, FROM } from '../../../constants/globalConstants';
import { useLocation, useNavigate } from 'react-router-dom';
import useLogin from '../../../hooks/useAuth';
import useCommunityList from '../../../hooks/useCommunityList';
import useClub from '../../../hooks/useClub';
import ajax from '../../../utils/ajaxHelper';
import SortableGridItem from '../Amenities/SortableGridItem';
import ClubDetailDialog from '../ClubsAndConnections/ClubDetailDialog';

// --- URL Query Param Helpers for Club Filter Persistence ---
const CLUB_FILTER_STORAGE_KEY = 'clubFilters_';

const serializeClubFilters = (filters) => {
  if (!filters || filters.length === 0) return '';
  try {
    const json = JSON.stringify(filters);
    return btoa(unescape(encodeURIComponent(json)));
  } catch (e) {
    console.error('Failed to encode club filters', e);
    return '';
  }
};

const deserializeClubFilters = (searchStr) => {
  const params = new URLSearchParams(searchStr);
  const raw = params.get('cf');
  if (!raw) return [];
  try {
    const json = decodeURIComponent(escape(atob(decodeURIComponent(raw))));
    return JSON.parse(json);
  } catch (e) {
    console.error('Failed to decode club filters from URL', e);
    return [];
  }
};

const saveClubFiltersToStorage = (communityId, filters) => {
  try {
    if (filters && filters.length > 0) {
      sessionStorage.setItem(CLUB_FILTER_STORAGE_KEY + communityId, JSON.stringify(filters));
    } else {
      sessionStorage.removeItem(CLUB_FILTER_STORAGE_KEY + communityId);
    }
  } catch (e) {
    // sessionStorage not available
  }
};

const loadClubFiltersFromStorage = (communityId) => {
  try {
    const raw = sessionStorage.getItem(CLUB_FILTER_STORAGE_KEY + communityId);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};
// --- End URL Query Param Helpers ---

const ClubCommunity = ({ communityInfo, isAccessible, publicView, onCommunityUpdate }) => {
  const communityDetails = communityInfo;
  const location = useLocation();
  const navigate = useNavigate();
  const communityId = communityInfo?.id;

  // Initialize selectedFilters: check URL first, then sessionStorage fallback
  const initialFiltersFromUrl = deserializeClubFilters(location.search);
  const initialFilters =
    initialFiltersFromUrl.length > 0
      ? initialFiltersFromUrl
      : loadClubFiltersFromStorage(communityId);

  const [clubFilterCategories, setClubFilterCategories] = useState([]);
  /* const userInfo = communityDetails?.ammenitiesInsight?.isAdminEntry
    ? repDetails
    : communityDetails?.userrole[0]; */
  //  const [isEditView, setIsEditView] = useState({ isAccessible });

  const executeOnClick = (isExpanded) => {};

  const handleClubClick = (club) => {
    setSelectedClub(club);
    setClubDetailOpen(true);
  };

  const handleClubDetailClose = () => {
    setClubDetailOpen(false);
    setSelectedClub(null);
  };

  const handleClubEdit = (club) => {
    // Navigate to edit page
    window.location.href = `/#/app/community-details-edit-add-new-club/${FROM.COMMUNITY_DETAILS}/${communityDetails?.id}/${club?.id}`;
  };

  const { getUserDataToAdmin } = useLogin();
  const { getClubsPaginated } = useClub();
  const [selectedFilters, setSelectedFilters] = useState(initialFilters);
  const [repDetails, setRepDetails] = useState();
  const [filteredClubs, setFilteredClubs] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [featuredClubs, setFeaturedClubs] = useState([]);
  const [clubsLoader, setClubsLoader] = useState(false);
  const [clubDetailOpen, setClubDetailOpen] = useState(false);
  const [selectedClub, setSelectedClub] = useState(null);
  const { getUserName, sortAmenities } = useCommunityList();
  const isInitialMount = useRef(true);

  // Helper: update URL and sessionStorage with current club filter state
  const updateUrlParams = useCallback(
    (filters) => {
      saveClubFiltersToStorage(communityId, filters);

      const params = new URLSearchParams(location.search);
      const encoded = serializeClubFilters(filters);
      if (encoded) {
        params.set('cf', encoded);
      } else {
        params.delete('cf');
      }
      const searchString = params.toString();
      navigate(`${location.pathname}${searchString ? `?${searchString}` : ''}`, { replace: true });
    },
    [navigate, location.pathname, location.search, communityId],
  );

  // Drag and drop state
  const [items, setItems] = useState([]);
  const [activeId, setActiveId] = useState(null);
  // const isAdmin = loggedInUserData?.roleId === 2;

  const [filteredClubsCount, setFilteredClubsCount] = useState(0);

  // Function to calculate potential result count based on selected type filters
  const calculatePotentialResultCount = (filters) => {
    if (filters.length === 0) {
      return featuredClubs?.length || 0;
    }

    // AND logic: show clubs that match all of the selected type filters
    const potentialResults = featuredClubs?.filter((club) => {
      const typeNames = (club?.clubTypes || []).map((t) => t.clubTypeName);
      return filters.every((filter) => typeNames.includes(filter));
    });

    return potentialResults?.length || 0;
  };

  const handleFilterSelection = (filter) => {
    let newSelectedFilters;
    if (selectedFilters.includes(filter)) {
      // Filter is already selected, so remove it.
      newSelectedFilters = selectedFilters.filter((selected) => selected !== filter);
    } else {
      // Filter is not selected, so add it.
      newSelectedFilters = [...selectedFilters, filter];
    }

    setSelectedFilters(newSelectedFilters);
    document.activeElement.blur();
  };

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterResultClick = () => {
    // If no filters are selected, show all clubs
    if (selectedFilters.length === 0) {
      setFilteredClubs(featuredClubs);
    } else {
      // AND logic: show clubs that match all of the selected type filters
      const filteredClubsArr = featuredClubs?.filter((club) => {
        const typeNames = (club?.clubTypes || []).map((t) => t.clubTypeName);
        return selectedFilters.every((filter) => typeNames.includes(filter));
      });
      setFilteredClubs(filteredClubsArr);
    }

    // Persist filters to URL and sessionStorage
    updateUrlParams(selectedFilters);

    // Close the filter popover
    setAnchorEl(null);
  };

  const getRepDetails = async () => {
    try {
      const repId = communityDetails?.clubInsight?.repId;
      if (repId) {
        const userDataResult = await getUserDataToAdmin({
          userIdd: repId,
        });
        setRepDetails(userDataResult.usersResult);
      }
    } catch (error) {
      console.error('Async function error:', error);
    }
  };

  // useEffect to update the count after filteredClubs is set
  useEffect(() => {
    if (filteredClubs && Array.isArray(filteredClubs)) {
      setFilteredClubsCount(filteredClubs.length);
    }
  }, [filteredClubs]);

  const resetFilters = () => {
    setSelectedFilters([]); // Reset the selected filters to an empty array
    setFilteredClubs(featuredClubs);
    updateUrlParams([]); // Clear URL and sessionStorage
    // The count will be updated automatically by the useEffect that watches filteredClubs
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  // Build grouped category → type structure for FilterComponent (generic shape)
  useEffect(() => {
    const catMap = {};
    const grouped = [];

    featuredClubs?.forEach((club) => {
      const cat = club?.clubCategory;
      if (!cat?.id) return;

      if (!catMap[cat.id]) {
        catMap[cat.id] = {
          id: cat.id,
          categoryName: cat.clubCategoryName,
          types: [],
        };
        grouped.push(catMap[cat.id]);
      }

      (club?.clubTypes || []).forEach((type) => {
        if (type?.id && !catMap[cat.id].types.some((t) => t.id === type.id)) {
          catMap[cat.id].types.push({
            id: type.id,
            typeName: type.clubTypeName,
          });
        }
      });
    });

    setClubFilterCategories(grouped);
  }, [featuredClubs]);

  useEffect(() => {
    if (communityDetails?.clubInsight?.repId) {
      getRepDetails();
    }
  }, [communityDetails?.clubInsight?.repId]);

  // Remove this useEffect as it's redundant - the count is already updated
  // by the useEffect that watches filteredAmenities changes

  useEffect(() => {
    if (!featuredClubs || featuredClubs.length === 0) {
      setFilteredClubs(featuredClubs);
      return;
    }

    // On initial mount, if we have persisted filters, auto-apply them
    if (isInitialMount.current && initialFilters.length > 0) {
      isInitialMount.current = false;
      const filteredClubsArr = featuredClubs.filter((club) => {
        const typeNames = (club?.clubTypes || []).map((t) => t.clubTypeName);
        return initialFilters.every((filter) => typeNames.includes(filter));
      });
      setFilteredClubs(filteredClubsArr);

      // If filters came from sessionStorage (no URL param), sync URL
      if (initialFiltersFromUrl.length === 0) {
        updateUrlParams(initialFilters);
      }
    } else {
      // Normal update when featuredClubs changes (e.g., after reorder)
      if (selectedFilters.length > 0) {
        const filteredClubsArr = featuredClubs.filter((club) => {
          const typeNames = (club?.clubTypes || []).map((t) => t.clubTypeName);
          return selectedFilters.every((filter) => typeNames.includes(filter));
        });
        setFilteredClubs(filteredClubsArr);
      } else {
        setFilteredClubs(featuredClubs);
      }
    }

    // Also set the initial count
    if (featuredClubs && Array.isArray(featuredClubs)) {
      setFilteredClubsCount(featuredClubs.length);
    }
  }, [featuredClubs]); // Add dependency to re-run when featured clubs change

  useEffect(() => {
    const loadFeaturedClubs = async () => {
      try {
        setClubsLoader(true);
        const response = await getClubsPaginated({
          communityId: communityInfo?.id,
          page: 1,
          limit: 1000,
          featuredOnly: true,
        });
        if (response?.clubsResult) {
          setFeaturedClubs(response.clubsResult);
        }
      } catch (error) {
        console.error('Error loading featured clubs:', error);
      } finally {
        setClubsLoader(false);
      }
    };

    if (communityInfo?.id) {
      loadFeaturedClubs();
    }
  }, [communityInfo?.id]);

  // Initialize items for drag and drop
  useEffect(() => {
    // Always update items when filteredClubs changes, even if it's empty
    if (filteredClubs) {
      setItems(filteredClubs);
    }
  }, [filteredClubs]);

  // Drag and drop functionality
  const saveClubsOrder = async (reorderedClubs) => {
    try {
      const resp = await ajax.post(
        `community/update-clubs-order`,
        {
          reorderedClubs,
        },
        {
          networkParams: { showLoader: false },
        },
      );
      // console.log('✅ Clubs have been reordered and changes were saved!', resp.data);
    } catch (err) {
      console.error('❌ Error updating club order:', err);
    }
  };

  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    setActiveId(null);

    if (!over || active.id === over.id) return;

    const oldIndex = items.findIndex((item) => item?.id === active.id);
    const newIndex = items.findIndex((item) => item?.id === over.id);
    let updatedItems = arrayMove(items, oldIndex, newIndex);
    setItems(updatedItems);

    if (featuredClubs?.length !== items?.length) {
      // Filtered view - need to update full clubs list
      updatedItems = [...sortAmenities(featuredClubs)]; // full list

      // Find positions in full list
      const activeIndexFull = updatedItems.findIndex((item) => item?.id === active.id);
      const overIndexFull = updatedItems.findIndex((item) => item?.id === over.id);

      if (activeIndexFull !== -1 && overIndexFull !== -1) {
        updatedItems = arrayMove(updatedItems, activeIndexFull, overIndexFull);
      }
    }

    // Update order numbers
    const reorderedClubs = updatedItems.map((club, index) => ({
      id: club.id,
      order: index + 1,
    }));

    await saveClubsOrder(reorderedClubs);

    // Update featured clubs state
    setFeaturedClubs(updatedItems);

    // Update filtered clubs if they're being displayed
    if (selectedFilters.length === 0) {
      setFilteredClubs(updatedItems);
    } else {
      const filteredClubsArr = updatedItems?.filter((club) => {
        const typeNames = (club?.clubTypes || []).map((t) => t.clubTypeName);
        return selectedFilters.every((filter) => typeNames.includes(filter));
      });
      setFilteredClubs(filteredClubsArr);
    }
  };

  const activeClub = activeId ? items.find((item) => item?.id === activeId) : null;
  return (
    <Paper className="WhitePaper" component="div">
      <Grid container>
        {/* <Grid item xs={12}>
        </Grid> */}
        <Grid item xs={12} className="BoxHeadingContainer">
          <Typography color="primary" variant="h2" className="BoxHeading">
            Clubs & Connections
          </Typography>
        </Grid>
        <If condition={isAccessible && !publicView}>
          {' '}
          <Grid item xs={12}>
            <Grid item xs={12} className="AddAmenityRow">
              <Box className="AddAmenityContentBox">
                <Typography variant="body2" className="AddLabel">
                  Adding clubs and connections helps users see what your community offers and find
                  the right fit.
                </Typography>
                <Button
                  className="AddButtonBox"
                  variant="outlined"
                  color="primary"
                  fullWidth
                  href={'/#/app/club-community-all/' + communityDetails?.id}
                  // href={`/#/app/community-details-edit-add-new-amenity/${FROM.COMMUNITY_DETAILS}/${communityDetails?.id}/default`}
                  startIcon={<AddCircleOutlineSharpIcon />}
                >
                  Feature A Club Or Connection
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} className="AddAmenityDividerRow">
              <Divider className="DividerCD"></Divider>
            </Grid>
          </Grid>
        </If>
        <If condition={!publicView || (publicView && filteredClubsCount > 0)}>
          <Grid item xs={12}>
            <Box mt={3}>
              <Typography variant="h3" component="h3" color="primary" className="Count">
                Featured
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} className="CommonDetailBoxGrid">
            {featuredClubs?.length > 0 && (
              <FilterComponent
                resultCount={filteredClubsCount}
                selectedFilters={selectedFilters}
                anchorEl={anchorEl}
                open={open}
                filtersGrouped={clubFilterCategories}
                onFilterClick={handleFilterClick}
                onFilterClose={handleFilterClose}
                onFilterSelection={handleFilterSelection}
                onResetFilters={resetFilters}
                onFilterResultClick={handleFilterResultClick}
                calculatePotentialResultCount={calculatePotentialResultCount}
                hasNoFilters={!clubFilterCategories || clubFilterCategories.length === 0}
                title="Club/Connection Filters"
              />
            )}
          </Grid>
        </If>
      </Grid>
      {featuredClubs?.length > 0 ? (
        <Box className="CommonDetailBoxGridSlider">
          {isAccessible ? (
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragStart={handleDragStart}
              onDragEnd={handleDragEnd}
              onDragCancel={() => setActiveId(null)}
            >
              <SortableContext
                items={items?.map((item) => item?.id)}
                strategy={rectSortingStrategy}
              >
                <Grid container spacing={2} className="DragDropContainer">
                  {(showMore ? items : items?.slice(0, 3))?.map((club) => (
                    <SortableGridItem key={club?.id} id={club?.id}>
                      <Box className="AmenitiesSliderBox" onClick={() => handleClubClick(club)}>
                        <Box className="SliderContainer">
                          {isAccessible && !publicView && (
                            <Button
                              className="EditCommonButtonFloatSecond"
                              href={`/#/app/community-details-edit-add-new-club/${FROM.COMMUNITY_DETAILS}/${communityDetails?.id}/${club?.id}`}
                              variant="outlined"
                              color="primary"
                              size="small"
                              startIcon={<EditPenIconGreen />}
                            >
                              Edit
                            </Button>
                          )}
                          <Carousel
                            navButtonsAlwaysVisible={true}
                            autoPlay={false}
                            className="SliderCarousel"
                            navButtonsProps={{
                              style: {
                                backgroundColor: '#000',
                                padding: '0',
                                opacity: 0.6,
                              },
                            }}
                            indicatorIconButtonProps={{
                              style: {
                                padding: '0px',
                                color: 'rgba(255, 255, 255, 0.6)',
                              },
                            }}
                            activeIndicatorIconButtonProps={{
                              style: {
                                padding: '0px',
                                color: 'rgba(255, 255, 255, 1)',
                              },
                            }}
                            indicatorContainerProps={{
                              style: {
                                marginTop: '0px',
                                position: 'absolute',
                                bottom: '5px',
                              },
                            }}
                          >
                            {club.clubGallery.length > 0 ? (
                              club.clubGallery.map((image, i) => (
                                <Paper key={i}>
                                  <Box className="CardBannerBox">
                                    <img
                                      src={
                                        window.location.hostname === 'localhost'
                                          ? `${backendLocalUrl}/${image.image}`
                                          : `api/${image.image}`
                                      }
                                    />
                                  </Box>
                                </Paper>
                              ))
                            ) : (
                              <Paper key="club-no-image">
                                <Box className="CardBannerBox">
                                  <img
                                    src={
                                      window.location.hostname === 'localhost'
                                        ? `${backendLocalUrl}/assets/images/NoImage.png`
                                        : `api/assets/images/NoImage.png`
                                    }
                                    alt="No Image"
                                  />
                                </Box>
                              </Paper>
                            )}
                          </Carousel>
                        </Box>
                        <Box className="SliderInfoContent">
                          <Typography variant="h6" className="AmenitiesCategory">
                            {club?.clubCategory?.clubCategoryName}
                          </Typography>
                          <Typography variant="h3" className="AmenitiesName">
                            {club?.clubName}
                          </Typography>
                          <Box className="AmenitiesAddess">
                            <Typography variant="caption" className="AmenitiesInsightLabel">
                              Address
                            </Typography>
                            <Typography variant="body2" className="AmenitiesInsight">
                              {club?.clubAddress || '-'}
                            </Typography>
                          </Box>
                          <Box className="AmenitiesText">
                            <Typography variant="caption" className="AmenitiesInsightLabel">
                              Description
                            </Typography>
                            <Typography
                              variant="body2"
                              className="AmenitiesInsight CommonDescription"
                            >
                              {club?.clubDesc || '-'}
                              {/* <ShowMoreText
                                lines={3}
                                more="Show More"
                                less="Show Less"
                                className="ReadMoreBox NoArrow"
                                anchorClass="show-more-less-clickable"
                                onClick={executeOnClick}
                                expanded={false}
                                truncatedEndingComponent={'... '}
                              >
                                {club?.clubDesc || '-'}
                              </ShowMoreText> */}
                            </Typography>
                            <Button
                              variant="text"
                              color="primary"
                              onClick={() => handleClubClick(club)}
                              className="LinkButton ShowMoreButtonLink"
                            >
                              Show More
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                    </SortableGridItem>
                  ))}
                </Grid>
              </SortableContext>

              <DragOverlay adjustScale style={{ transformOrigin: '0 0' }}>
                {activeClub ? (
                  <div
                    style={{
                      cursor: 'grabbing',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                      backgroundColor: 'white',
                    }}
                  >
                    <Box className="AmenitiesSliderBox">
                      <Box className="SliderContainer">
                        {isAccessible && !publicView && (
                          <Button
                            className="EditCommonButtonFloatSecond"
                            href={`/#/app/community-details-edit-add-new-club/${FROM.COMMUNITY_DETAILS}/${communityDetails?.id}/${activeClub?.id}`}
                            variant="outlined"
                            color="primary"
                            size="small"
                            startIcon={<EditPenIconGreen />}
                          >
                            Edit
                          </Button>
                        )}
                        <Carousel
                          navButtonsAlwaysVisible={true}
                          autoPlay={false}
                          className="SliderCarousel"
                          navButtonsProps={{
                            style: {
                              backgroundColor: '#000',
                              padding: '0',
                              opacity: 0.6,
                            },
                          }}
                          indicatorIconButtonProps={{
                            style: {
                              padding: '0px',
                              color: 'rgba(255, 255, 255, 0.6)',
                            },
                          }}
                          activeIndicatorIconButtonProps={{
                            style: {
                              padding: '0px',
                              color: 'rgba(255, 255, 255, 1)',
                            },
                          }}
                          indicatorContainerProps={{
                            style: {
                              marginTop: '0px',
                              position: 'absolute',
                              bottom: '5px',
                            },
                          }}
                        >
                          {activeClub.clubGallery.length > 0 ? (
                            activeClub.clubGallery.map((image, i) => (
                              <Paper key={i}>
                                <Box className="CardBannerBox">
                                  <img
                                    src={
                                      window.location.hostname === 'localhost'
                                        ? `${backendLocalUrl}/${image.image}`
                                        : `api/${image.image}`
                                    }
                                  />
                                </Box>
                              </Paper>
                            ))
                          ) : (
                            <Paper key="club-no-image">
                              <Box className="CardBannerBox">
                                <img
                                  src={
                                    window.location.hostname === 'localhost'
                                      ? `${backendLocalUrl}/assets/images/NoImage.png`
                                      : `api/assets/images/NoImage.png`
                                  }
                                  alt="No Image"
                                />
                              </Box>
                            </Paper>
                          )}
                        </Carousel>
                      </Box>
                      <Box className="SliderInfoContent">
                        <Typography variant="h6" className="AmenitiesCategory">
                          {activeClub?.clubCategory?.clubCategoryName}
                        </Typography>
                        <Typography variant="h3" className="AmenitiesName">
                          {activeClub?.clubName}
                        </Typography>
                        <Box className="AmenitiesAddess">
                          <Typography variant="caption" className="AmenitiesInsightLabel">
                            Address
                          </Typography>
                          <Typography variant="body2" className="AmenitiesInsight">
                            {activeClub?.clubAddress || '-'}
                          </Typography>
                        </Box>
                        <Box className="AmenitiesText">
                          <Typography variant="caption" className="AmenitiesInsightLabel">
                            Description
                          </Typography>
                          <Typography
                            variant="body2"
                            className="AmenitiesInsight CommonDescription"
                          >
                            {activeClub?.clubDesc || '-'}
                            {/* <ShowMoreText
                              lines={3}
                              more="Show More"
                              less="Show Less"
                              className="ReadMoreBox NoArrow"
                              anchorClass="show-more-less-clickable"
                              onClick={executeOnClick}
                              expanded={false}
                              truncatedEndingComponent={'... '}
                            >
                              {activeClub?.clubDesc || '-'}
                            </ShowMoreText> */}
                          </Typography>
                          <Button
                            variant="text"
                            color="primary"
                            onClick={() => handleClubClick(activeClub)}
                            className="LinkButton ShowMoreButtonLink"
                          >
                            Show More
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  </div>
                ) : (
                  ''
                )}
              </DragOverlay>
            </DndContext>
          ) : (
            <Grid container spacing={2}>
              {(showMore ? filteredClubs : filteredClubs?.slice(0, 3))?.map((club) => (
                <Grid item xs={12} sm={6} md={4} key={club?.id}>
                  <Box className="AmenitiesSliderBox" onClick={() => handleClubClick(club)}>
                    <Box className="SliderContainer">
                      {isAccessible && !publicView && (
                        <Button
                          className="EditCommonButtonFloatSecond"
                          href={`/#/app/community-details-edit-add-new-amenity/${FROM.COMMUNITY_DETAILS}/${communityDetails?.id}/${club?.id}`}
                          variant="outlined"
                          color="primary"
                          size="small"
                          startIcon={<EditPenIconGreen />}
                        >
                          Edit
                        </Button>
                      )}
                      <Carousel
                        navButtonsAlwaysVisible={true}
                        autoPlay={false}
                        className="SliderCarousel"
                        navButtonsProps={{
                          style: {
                            backgroundColor: '#000',
                            padding: '0',
                            opacity: 0.6,
                          },
                        }}
                        indicatorIconButtonProps={{
                          style: {
                            padding: '0px',
                            color: 'rgba(255, 255, 255, 0.6)',
                          },
                        }}
                        activeIndicatorIconButtonProps={{
                          style: {
                            padding: '0px',
                            color: 'rgba(255, 255, 255, 1)',
                          },
                        }}
                        indicatorContainerProps={{
                          style: {
                            marginTop: '0px',
                            position: 'absolute',
                            bottom: '5px',
                          },
                        }}
                      >
                        {club.clubGallery.length > 0 ? (
                          club.clubGallery.map((image, i) => (
                            <Paper key={i}>
                              <Box className="CardBannerBox">
                                <img
                                  src={
                                    window.location.hostname === 'localhost'
                                      ? `${backendLocalUrl}/${image.image}`
                                      : `api/${image.image}`
                                  }
                                />
                              </Box>
                            </Paper>
                          ))
                        ) : (
                          <Paper key="club-no-image">
                            <Box className="CardBannerBox">
                              <img
                                src={
                                  window.location.hostname === 'localhost'
                                    ? `${backendLocalUrl}/assets/images/NoImage.png`
                                    : `api/assets/images/NoImage.png`
                                }
                                alt="No Image"
                              />
                            </Box>
                          </Paper>
                        )}
                      </Carousel>
                    </Box>
                    <Box className="SliderInfoContent">
                      <Typography variant="h6" className="AmenitiesCategory">
                        {club?.clubCategory?.clubCategoryName}
                      </Typography>
                      <Typography variant="h3" className="AmenitiesName">
                        {club?.clubName}
                      </Typography>
                      <Box className="AmenitiesAddess">
                        <Typography variant="caption" className="AmenitiesInsightLabel">
                          Address
                        </Typography>
                        <Typography variant="body2" className="AmenitiesInsight">
                          {club?.clubAddress || '-'}
                        </Typography>
                      </Box>
                      <Box className="AmenitiesText">
                        <Typography variant="caption" className="AmenitiesInsightLabel">
                          Description
                        </Typography>
                        <Typography variant="body2" className="AmenitiesInsight CommonDescription">
                          {club?.clubDesc || '-'}
                          {/* <ShowMoreText
                            lines={3}
                            more="Show More"
                            less="Show Less"
                            className="ReadMoreBox NoArrow"
                            anchorClass="show-more-less-clickable"
                            onClick={executeOnClick}
                            expanded={false}
                            truncatedEndingComponent={'... '}
                          >
                            {club?.clubDesc || '-'}
                          </ShowMoreText> */}
                        </Typography>
                        <Button
                          variant="text"
                          color="primary"
                          onClick={() => handleClubClick(club)}
                          className="LinkButton ShowMoreButtonLink"
                        >
                          Show More
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      ) : (
        ''
      )}
      {filteredClubs?.length > 3 && (
        <Grid container>
          <Grid item xs={12} className="ShowButton">
            <Button
              className="ShowHideAllButton"
              startIcon={showMore ? <ExpandLess /> : <ExpandMore />}
              onClick={() => setShowMore(!showMore)}
            >
              {showMore ? 'Show Less' : 'Show All'}
            </Button>
          </Grid>
        </Grid>
      )}
      {/* {amenityCategories.length > 0 && (
        <Grid container className="ListActivitiesContainer">
          <Grid item xs={12}>
            <Typography variant="h3" component="h3" color="primary" className="Count">
              More to experience in {communityInfo?.communityNameText || ''}
            </Typography>
            <Divider className="GreenDividerColor ListActivitiesDivider" />
          </Grid>
         
          
          {amenityCategories?.map((category) => {
            return (
              <Grid item xs={12} key={category.id}>
                <Typography
                  variant="body2"
                  component="div"
                  className="BlackColor ListActivitiesHeading"
                >
                  {category.amenityCategoryName}:
                </Typography>
                <Box className="ListActivitiesBox">
                  <List component="ul" className="ActivitiesList">
                    {category?.amenityType.map((amenityType) => (
                      <ListItem key={amenityType.id}>{amenityType.amenityTypeName}</ListItem>
                    ))}
                  </List>
                </Box>
              </Grid>
            );
          })}

        </Grid>
      )} */}

      <Grid container>
        {/* {((isAccessible && */}
        {/* {filteredAmenities.length > 0 && (
          <Grid item xs={12} className="ViewButton">
            <Link
              href={'/#/app/view-all-amenities/' + communityDetails?.id}
              underline="none"
              color="primary"
              className="RightFloatBtn"
            >
              View all Amenities
              <Box component="span" marginLeft={1}>
                <ArrowForwardIcon className="" />
              </Box>
            </Link>
          </Grid>
        )} */}
        <If condition={communityDetails?.clubInsight?.clubDesc}>
          <Grid
            item
            xs={12}
            className={
              communityDetails?.amenities?.length > 0 || isAccessible ? 'ChatBoxContainer' : ''
            }
          >
            {isAccessible && !publicView && communityDetails?.clubInsight?.clubDesc !== '' && (
              <Button
                className="EditCommonButtonFloat"
                variant="outlined"
                color="primary"
                size="small"
                startIcon={<EditPenIconGreen />}
                href={'/#/app/community-details-edit-clubs/' + communityDetails?.id}
              >
                Edit
              </Button>
            )}
            <Box className="ChatBox CommonDetailBoxGrid">
              {communityDetails?.clubInsight && (
                <Box className="ChatContent">
                  <Typography variant="body2" className="ChatText" color="primary">
                    {communityDetails?.clubInsight?.clubDesc}
                  </Typography>
                </Box>
              )}
              <SectionUserInfo
                communityDetails={communityDetails}
                repDetails={repDetails}
                isAdminEntry={communityDetails?.clubInsight?.isAdminEntry}
                getUserNameFunction={getUserName}
              />
            </Box>
          </Grid>
        </If>
        {isAccessible && !publicView && (
          <>
            <Grid item xs={12}>
              {isAccessible && !publicView && !communityDetails?.clubInsight?.clubDesc && (
                <Box>
                  <Typography variant="body2" className="InsightLabel">
                    Here’s where you can describe your community’s clubs and connections.
                  </Typography>
                </Box>
              )}
            </Grid>
          </>
        )}
      </Grid>
      <If condition={isAccessible && !publicView && !communityDetails?.clubInsight?.clubDesc}>
        <Grid item xs={12}>
          <div className="Wrapper ButtonWrapper InsightButtonContainer">
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              href={'/#/app/community-details-edit-clubs/' + communityDetails?.id}
            >
              {communityDetails?.clubInsight?.clubDesc ? ' Edit' : ' Add'}
              <Box className="AddButton">Insight</Box>
            </Button>
          </div>
        </Grid>
      </If>

      {/* Club Detail Dialog */}
      <ClubDetailDialog
        open={clubDetailOpen}
        onClose={handleClubDetailClose}
        clubData={selectedClub}
        onEdit={handleClubEdit}
        publicView={publicView}
        isAccessible={isAccessible}
      />
    </Paper>
  );
};

export default ClubCommunity;
